module.exports = __webpack_public_path__ + "static/media/no-workspaces-heardy.6f6a3ca7.svg";